// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-avatar-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}

.profile-avatar-column {
  display: flex;
  flex-direction: column;
}

.profile-avatar-row {
  margin-left: 20px;
  margin-bottom: 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: #6C7275;
}

.profile-avatar-row label {
  border-radius: 12px;
  border: 2px solid var(--neutral-03100, #E8ECEF);
  background-color: white;
  color: #141718;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
}

.profile-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.profile-content h5 {
  letter-spacing: 0.5px;
}

.profile-section {
  margin-top: 15px;
}

.profile-section h5 {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}

.profile-content .form-group {
  margin-bottom: 0px;
}

.profile-content .form-group label {
  color: #141718;
}

.profile-input-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  gap: 12px;
  background: #f3f5f7;
  border-radius: 12px;
}

.user-info {
  display: flex;
  flex-direction: row;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Profile/profile.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,+CAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAGA;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADF","sourcesContent":[".profile-avatar-container {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n}\n\n.profile-avatar-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.profile-avatar-row {\n  margin-left: 20px;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  color: #6C7275;\n}\n\n.profile-avatar-row label {\n  border-radius: 12px;\n  border: 2px solid var(--neutral-03100, #E8ECEF);\n  background-color: white;\n  color: #141718;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px 24px;\n\n}\n\n.profile-content {\n  padding: 30px 24px 30px 24px;\n  gap: 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n}\n\n.profile-content h5 {\n  letter-spacing: 0.5px;\n}\n\n.profile-section {\n  margin-top: 15px;\n}\n\n.profile-section h5 {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.profile-content .form-group {\n  margin-bottom: 0px;\n}\n\n.profile-content .form-group label {\n  color: #141718;\n}\n\n\n.profile-input-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 14px 16px;\n  gap: 12px;\n  background: #f3f5f7;\n  border-radius: 12px;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: row;\n  gap: 20px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
